module.exports = __webpack_public_path__ + "static/media/line-size-2.021b3a45.svg";